module.exports = __webpack_public_path__ + "img/OMG-alt.5872cb84.svg";